import * as ActionTypes from '../ActionTypes';

const leaveTypeInitialState = {
    isLoading: false,
    success: false,
    error: false,
    successMessage: "",
    errorMessage: "",
    leave_credit : [],
    leaveCreditLoading: false
}

export const LeaveTypeReducer = function (state = leaveTypeInitialState, action) {
    switch (action.type) {
        case ActionTypes.LEAVE_TYPE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
                leavetypes_options: []
            };
        case ActionTypes.LEAVE_TYPE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavetypes_options: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_TYPE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_TYPE_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_TYPE_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavetypes_options: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_TYPE_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_TYPE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_TYPE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavetypes_options: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_TYPE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_TYPE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavetypes_options: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_TYPE_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.GET_LEAVE_CREDIT_CONFIG_REQUEST :
            return {
                ...state,
                leaveCreditLoading: true,
                success: false,
                successMessage: "",
                error: false,
                leave_credit: []
            };
        case ActionTypes.LEAVE_CREDIT_CONFIG_UPDATE_REQUEST :
            return {
                ...state,
                leaveCreditLoading: true,
                error: false,
            };
        case ActionTypes.GET_LEAVE_CREDIT_CONFIG_SUCCESS :
        case ActionTypes.LEAVE_CREDIT_CONFIG_UPDATE_SUCCESS :
            return {
                ...state,
                leaveCreditLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leave_credit: action.payload?.data?.data
            };
        case ActionTypes.GET_LEAVE_CREDIT_CONFIG_ERROR :
        case ActionTypes.LEAVE_CREDIT_CONFIG_UPDATE_ERROR :
            return {
                ...state,
                leaveCreditLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        default:
            return state;
    }
}